import { useId } from 'react';
import { FacebookFollowLink } from './FacebookFollowLink';
import './SubcategoryBrowseFacebookInline.css';

function BetaBadge() {
  return <span className="browse-facebook-inline__beta-badge">BETA</span>;
}

/**
 * @param {{
 *   scopeLabel: string;
 *   location?: string;
 *   onShare: () => void;
 * }} props
 */
export function SubcategoryBrowseFacebookInline({
  scopeLabel,
  location = 'subcategory_browse',
  onShare,
}) {
  const headingId = useId();
  const name =
    typeof scopeLabel === 'string' && scopeLabel.trim() !== ''
      ? scopeLabel.trim()
      : 'this category';

  return (
    <li className="results-page__cell results-page__cell--facebook-inline">
      <aside
        className="browse-facebook-inline"
        aria-labelledby={headingId}
      >
        <div className="browse-facebook-inline__content">
          <div className="browse-facebook-inline__heading">
            <BetaBadge />
            <p id={headingId} className="browse-facebook-inline__label">
              Help us build better coverage
            </p>
          </div>
          <p className="browse-facebook-inline__lede">
          We're in beta, growing fast - Every share helps us add more Malta shops and improve search quality for you and others!
          </p>
        </div>
        <div className="browse-facebook-inline__actions">
          <button
            type="button"
            className="browse-facebook-inline__share-btn"
            onClick={onShare}
          >
            Share
          </button>
          <FacebookFollowLink
            location={location}
            className="browse-facebook-inline__btn"
          />
        </div>
      </aside>
    </li>
  );
}
